import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useI18n } from "../i18n/LanguageProvider";

// crumbs: [{ name, to }] — the current page is the last item (no link).
export default function Breadcrumbs({ crumbs = [], className = "" }) {
  const { t, p } = useI18n();
  const all = [{ name: t.common.home, to: p("home") }, ...crumbs];

  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={className}>
      <ol className="flex flex-wrap items-center gap-1.5 text-[13px] text-navy/55">
        {all.map((c, i) => {
          const isLast = i === all.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {isLast ? (
                <span className="font-semibold text-navy/80" aria-current="page">
                  {c.name}
                </span>
              ) : (
                <>
                  <Link to={c.to} className="hover:text-dental transition-colors">
                    {c.name}
                  </Link>
                  <ChevronRight className="h-3.5 w-3.5 text-navy/30" />
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
